import { KeycloakConfig } from '@src/config/baseAppConfig.types';
import defaultClaimsKeys from './defaultClaimsKeys';

export const prodKeycloakConfig: KeycloakConfig = {
  keycloakAuthUrl: 'https://services.sentinel-hub.com/auth',
  keycloakRealm: 'main',
  ...defaultClaimsKeys,
};
